import types from "cms/enums/contentsTypes.enum";
export var text = {
    label: "Zone de texte",
    type: types.TEXT,
    editionModalPosition: "top",
    icon: "text",
    value: ""
};
